export default __webpack_public_path__ + "static/docstation-dcfbe624c3e3dbe4d6d9687a1164c4d9.png";